import { FieldValues, FormState } from 'react-hook-form';
import type { TextFieldProps } from '@carrotfertility/carotene-core';
import { RequireNameProp } from './form-types';

type GetFormInputState<T extends FieldValues> = Pick<FormState<T>, 'errors'> &
    RequireNameProp &
    Pick<TextFieldProps, 'error' | 'helperText'>;

function flatten(obj: Record<string, FieldValues['errors']>) {
    const result: Record<string, FieldValues['errors']> = {};
    for (const key of Object.keys(obj)) {
        if (typeof obj[key] === 'object' && !obj[key]?.message && !obj[key]?.type) {
            const nested = flatten(obj[key] as Record<string, FieldValues['errors']>);
            for (const nestedKey of Object.keys(nested)) {
                result[`${key}.${nestedKey}`] = nested[nestedKey];
            }
        } else {
            result[key] = obj[key];
        }
    }
    return result;
}

export function getFormInputState<T extends FieldValues>(args: GetFormInputState<T>) {
    const errors = flatten(args.errors);
    return {
        error: args?.error || Boolean(errors[args?.name]),
        helperText: errors[args?.name] ? errors[args?.name]?.message?.toString() : args?.helperText,
    };
}
